import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "sonner";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Portal from "./pages/Portal";
import NewVessel from "./pages/NewVessel";
import VesselDetail from "./pages/VesselDetail";
import History from "./pages/History";
import Approvals from "./pages/Approvals";
import Analytics from "./pages/Analytics";
import Certificate from "./pages/Certificate";
import Members from "./pages/Members";
import Lineup from "./pages/Lineup";
import FELOperator from "./pages/FELOperator";
import ComingSoon from "./pages/ComingSoon";
import ForgotPassword from "./pages/ForgotPassword";
import EngagementSurvey from "./pages/EngagementSurvey";
import HRDashboard from "./pages/HRDashboard";
import RailOperationsDashboard from "./pages/RailOperationsDashboard";
import RailConsignmentsList from "./pages/RailConsignmentsList";
import ClientDashboard from "./pages/ClientDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import ImpersonationBanner from "./components/ImpersonationBanner";

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <div className="App">
                    <ImpersonationBanner />
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/engagement-survey" element={<EngagementSurvey />} />
                        <Route
                            path="/client"
                            element={
                                <ProtectedRoute roles={["client"]}>
                                    <ClientDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/hr-dashboard"
                            element={
                                <ProtectedRoute roles={["hr", "admin"]}>
                                    <HRDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/rail-operations"
                            element={
                                <ProtectedRoute roles={[
                                    "admin", "manager", "supervisor",
                                    "plant_manager", "safety", "client_liaison",
                                    "finance", "fleet_manager", "shift_millwright",
                                    "electrician", "hr",
                                    "tfr_yard", "rail_coordinator", "mine_rail_planner",
                                ]}>
                                    <RailOperationsDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/rail-consignments"
                            element={
                                <ProtectedRoute roles={[
                                    "admin", "manager", "supervisor",
                                    "plant_manager", "safety", "client_liaison",
                                    "finance", "fleet_manager", "shift_millwright",
                                    "electrician", "hr",
                                    "tfr_yard", "rail_coordinator", "mine_rail_planner",
                                    "tippler_operator",
                                ]}>
                                    <RailConsignmentsList />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/coming-soon"
                            element={
                                <ProtectedRoute>
                                    <ComingSoon />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/fel"
                            element={
                                <ProtectedRoute roles={["fel_operator", "admin", "manager"]}>
                                    <FELOperator />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/portal"
                            element={
                                <ProtectedRoute>
                                    <Portal />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute>
                                    <Dashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/vessel/new"
                            element={
                                <ProtectedRoute roles={["supervisor"]}>
                                    <NewVessel />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/vessel/:id"
                            element={
                                <ProtectedRoute>
                                    <VesselDetail />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/history"
                            element={
                                <ProtectedRoute>
                                    <History />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/lineup"
                            element={
                                <ProtectedRoute>
                                    <Lineup />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/approvals"
                            element={
                                <ProtectedRoute roles={["admin", "manager"]}>
                                    <Approvals />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/members"
                            element={
                                <ProtectedRoute roles={["admin", "manager"]}>
                                    <Members />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/analytics"
                            element={
                                <ProtectedRoute roles={["admin", "manager"]}>
                                    <Analytics />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/vessel/:id/certificate"
                            element={
                                <ProtectedRoute>
                                    <Certificate />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="/" element={<Navigate to="/portal" replace />} />
                        <Route path="*" element={<Navigate to="/portal" replace />} />
                    </Routes>
                    <Toaster position="top-center" richColors closeButton />
                </div>
            </BrowserRouter>
        </AuthProvider>
    );
}
